module.exports = __webpack_public_path__ + "img/dcms06.6b256c79.png";